module.exports = __webpack_public_path__ + "img/phones2.705f8fe.jpg";